import { FC } from 'react';

type ErrorDialogType = "left" | "right" | "bottom";

interface ArrowNotificationProps {
    text: string;
    type: ErrorDialogType;
    title?: string;
    icon?: string;
    iconText?: string;
    width?: string;
}
const ArrowNotification: FC<ArrowNotificationProps> = (props) => {
    const { text, type, title, icon, iconText, width } = props

    const renderArrowPosition = () => {
        if (type === "left") return "notification_ridge-left";
        if (type === "right") return "notification_ridge-right";
        if (type === "bottom") return "notification_ridge-bottom";
    }

    const floatOnTheRightDirection = () => {
        if (type === "right") return "notification_body_wrapper move_left swing_notification";
        if (type === "left") return "notification_body_wrapper mover_right swing_notification";
        if (type === "bottom") return "swing_notification_vertically_up_and_down";
    }

    return (
        <div className={`${floatOnTheRightDirection()}`} style={{ width: `${width}` }}>
            <div className="notification_body">
                {title && <p className="notification_title">{title}</p>}
                <p className="notification_text">{text}</p>
                {icon && <div className="notification_icon_wrapper">
                    {icon && <img src={icon} className="notification_icon" alt="icon" />}
                    <p className="notification_icon_text">{iconText}</p>
                </div>}
                <div className={`notification_ridge ${renderArrowPosition()}`} > </div>
            </div>
        </div>
    );
}

export default ArrowNotification;